import {Component, Input, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LMFieldBaseComponent} from '@field/lm-field-base.component';
import {LMModel, LMModelChangedEvent} from '@form/model';
import {LMFieldServiceAdapter} from '@field/lm-field-service-adapter';
import {LMLplEditorService} from '@lplEditor/lm-lpl-editor.service';
import {LMLplEditorComponent} from '@components/lplEditor';

@Component({
  selector:    'lm-field-editor',
  templateUrl: './lm-field-editor.component.html',
  styleUrls:   [ 'lm-field-editor.component.scss' ]
})

export class LMFieldEditorComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {

  @ViewChild('LplEditor') lplEditorComponent: LMLplEditorComponent;

  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  public rows: number = undefined;
  public editorValidationOptions: LMEditorValidationOptions = undefined;
  public editorLpl: string;
  constructor(
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    protected lmLplEditorService: LMLplEditorService,
    private ngZone: NgZone) {
    super(lmFieldServiceAdapter);
  }

  // events
  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);
    // see JFieldClobTextArea > DEFAULT_TEXTAREA_LINES
    this.rows = (this.layoutObject.lines === undefined || this.layoutObject.lines === 0) ? 4 : this.layoutObject.lines;

    if (!this.displayAsText) {
      this.subscribeToInlineError();
    }

    this.setSize();
    this.setFieldClasses();

    this.editorLpl = this.modelField.value;
    this.editorValidationOptions = this.lmLplEditorService.createValidationOptions(this.specField.lplValSpec, this.model);

    this.subscriptionArray.push(this.model.modelChanged
      .subscribe((modelChangedEvent: LMModelChangedEvent) => {
        if (modelChangedEvent.eventType === 'set') {
          // update the input to pass it to the lm-lpl-editor!
          this.handleModelChanged();
        }
      })
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  }

  onLplChangedEvent(lpl: string) {
    this.ngZone.run(args => this.handleLplChanged(lpl));
  }

  private handleLplChanged(lpl: string) {
    this.modelField.value = lpl;
    this.isDirty = this.model.evaluateAndApplyDirtyState(this.bindId);
  }

  private handleModelChanged() {
    // need to set input on the component for the change detection to work!
    if (this.lplEditorComponent) {
      this.lplEditorComponent.lpl = this.modelField.value;
      this.lplEditorComponent.validationOptions = this.lmLplEditorService.createValidationOptions(this.specField.lplValSpec, this.model);
    }
  }
}
